var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.806 17.778C17.9475 17.778 20.6798 20.2696 21.4742 23.8325C21.5946 24.35 21.2576 24.8676 20.74 24.9759C20.6678 24.988 20.5956 25 20.5354 25C20.09 25 19.6928 24.6991 19.5965 24.2417C19.0067 21.5696 17.0327 19.6919 14.806 19.6919H6.68129C4.45452 19.6919 2.48052 21.5575 1.89073 24.2417C1.7824 24.7593 1.26483 25.0843 0.747256 24.9759C0.229683 24.8556 -0.0953046 24.35 0.0250612 23.8325C0.807439 20.2696 3.55178 17.778 6.69333 17.778H14.806ZM17.8151 8.99133C17.8151 12.8912 14.6375 16.0688 10.7376 16.0688C6.83776 16.0688 3.66011 12.8912 3.66011 8.99133V7.07752C3.66011 3.17766 6.83776 0 10.7376 0C14.6375 0 17.8151 3.17766 17.8151 7.07752V8.99133ZM10.7497 1.91382C7.90902 1.91382 5.598 4.22484 5.598 7.06548V8.9793C5.598 11.8199 7.90902 14.131 10.7497 14.131C13.5903 14.131 15.9013 11.8199 15.9013 8.9793V7.07752C15.9013 4.22484 13.5903 1.91382 10.7497 1.91382Z",
    fill: "#575757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ee2d9194.svg";
export { ForwardRef as ReactComponent };